export default __webpack_public_path__ + "static/media/search.c51e3ca2.svg";